<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm ref="form" :form="form" :rules="rules" :labelWidth="labelWidth" :formGroups="formGroups"
      :viewMode="viewMode" @onInput="onInput" @onSelect="onSelect" @onChange="onChange">
    </MyForm>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">{{ mode === 'edit' ? '取 消' : '返 回' }}</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'contract',
      breadcrumb: [
        { name: "合同管理", path: `/contract/list` },
        { name: "合同列表", path: `/contract/list` },
        { name: "合同添加" },
      ],
      form: {
        pricing: undefined,
        pricing_id: undefined,
        shipperid: undefined,
        nid: undefined,
        cprice: undefined,
        dprice: undefined,
        drman: undefined,
        drtel: undefined,
        coaddress: undefined,
        enman: undefined,
        ertel: undefined,
        enaddress: undefined,
        ton: undefined,
      },
      rules: {
        pricing_id: [
          { required: true, message: "请选择计价方式", trigger: "blur" },
        ],
        pricing: [
          { required: true, message: "请选择计价方式", trigger: "blur" },
        ],
        shname: [
          { required: true, message: "请选择客户名称", trigger: "blur" },
        ],
        // timerange: [
        //   { required: true, message: "请选择合同期限", trigger: "blur" },
        // ],
        name: [
          { required: true, message: "请选择货物名称", trigger: "blur" },
        ],
        ton: [
          {
            required: true,
            validator: this.checkTon,
            // message: "请填写合同量",
            trigger: "blur",
          },
        ],
        cprice: [
          { required: true, message: "请填写公司单价", trigger: "blur" },
        ],
        // dprice: [
        //   { required: true, message: "请填写司机单价", trigger: "blur" },
        // ],
        drman: [
          { required: true, message: "请填写装货联系人", trigger: "blur" },
        ],
        drtel: [
          { required: true, validator: this.checkPhone, trigger: "blur" },
        ],
        coaddress: [
          { required: true, message: "请填写装货地址", trigger: "blur" },
        ],
        enman: [
          { required: true, message: "请填写卸货联系人", trigger: "blur" },
        ],
        ertel: [
          { required: true, validator: this.checkPhone, trigger: "blur" },
        ],
        enaddress: [
          { required: true, message: "请填写卸货地址", trigger: "blur" },
        ],
      },
      formGroups: [
        {
          title: '基础信息',
          formCtrl: [
            {
              label: "合同编号",
              keyName: "con_num",
              err: "请填写合同编号",
              type: "text",
              disabled: true,
            },
            {
              label: "客户名称",
              keyName: "shname",
              err: "请选择客户名称",
              type: "select",
              options: [],
            },
            {
              label: "合同期限",
              keyName: "timerange",
              err: "请选择合同期限",
              type: "daterange",
              unit: "(选填)",
            },
            {
              label: "货物名称",
              keyName: "name",
              err: "请选择货物名称",
              type: "select",
              options: [],
            },
            {
              label: "计价方式",
              keyName: "pricing",
              type: "select",
              options: [],
            },
            {
              label: "合同量",
              keyName: "ton",
              err: "请填写合同量",
              type: "number",
            },
            {
              label: "公司单价",
              keyName: "cprice",
              err: "请填写公司单价",
              type: "number",
            },
            {
              label: "司机单价",
              keyName: "dprice",
              err: "请填写司机单价",
              type: "number",
            },
          ],
        },
        {
          title: '装货信息',
          formCtrl: [
            {
              label: "装货地址",
              keyName: "coaddress",
              err: "请填写装货地址",
              type: "text",
              options: [],
            },
            {
              label: "装货联系人",
              keyName: "drman",
              err: "请填写装货联系人",
              type: "text",
              options: [],
            },
            {
              label: "装货人电话",
              keyName: "drtel",
              err: "请填写装货电话",
              type: "number",
            },
          ],
        },
        {
          title: '卸货信息',
          formCtrl: [
            {
              label: "卸货地址",
              keyName: "enaddress",
              err: "请填写卸货地址",
              type: "text",
              options: [],
            },
            {
              label: "卸货联系人",
              keyName: "enman",
              err: "请填写卸货联系人",
              type: "text",
              options: [],
            },
            {
              label: "卸货人电话",
              keyName: "ertel",
              err: "请填写卸货电话",
              type: "number",
            },
          ],
        },
      ],
      custom: [],
      product: [],
      pricing: [],
    };
  },
  methods: {
    onChange({ key, value }) {
      if (key === 'shname') {
        // console.log('onChange', key, value)
        this.$set(this.form, key, value)
        this.custom.map(v => {
          if (v.name + '-' + v.member === value) {
            this.$set(this.form, 'shipperid', v.id)
          }
        })
        // console.log(this.form[key])
      } else if (key === 'name') {
        // console.log('onChange', key, value)
        this.$set(this.form, key, value)
        this.product.map(v => {
          if (v.name === value) {
            this.$set(this.form, 'nid', v.id)
          }
        })
        // console.log(this.form[key])
      } else if (key === 'pricing') {
        this.$set(this.form, key, value)
        this.pricing.map(v => {
          if (value === v.name) {
            this.$set(this.form, 'pricing_id', v.id)
          }
        })
      }
    },
    checkTon(rule, value, callback) {
      // console.log(rule, value)
      // console.log(Number(value))
      if (Number(value) <= 0) {
        callback(new Error('合同量必须大于0'));
      } else if (!Number(value)) {
        callback(new Error('请填写合同量'));
      } else {
        callback();
      }
    },
    setDetail() {
      const formCtrl = []
      const { isstatus } = this.detail
      // console.log(isstatus)
      if (isstatus != 1) {
        // 除待派单外不可修改货物名称和计价方式
        this.formGroups[0].formCtrl[3].disabled = true
        this.formGroups[0].formCtrl[4].disabled = true
      }
      this.formGroups.map(v => {
        if (v.formCtrl) {
          formCtrl.push(...v.formCtrl)
        }
      })
      const { starttime, endtime } = this.detail
      formCtrl.map(v => {
        const key = v.keyName
        this.$set(this.form, key, this.detail[key])
        if (key === 'timerange' && starttime && endtime) {
          this.$set(this.form, key, [starttime, endtime])
        }
      })
      this.setPricingName()
      this.setCustom()
      this.$forceUpdate()
      console.log('合同编辑')
      // console.log('detail', { ...this.detail })
      // console.log('form', { ...this.form })
    },
    paramsPackage(params, object) {
      // console.log({ ...params }, { ...object })
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key) && key !== 'timerange') {
          params[key] = object[key];
        }
      }
      if (object['timerange']) {
        const [starttime, endtime] = object['timerange']
        params['starttime'] = starttime
        params['endtime'] = endtime
      }
      const { isstatus } = this.detail
      params['isstatus'] = isstatus
      // console.log({ ...params }, { ...object })
    },
    setOptions({ custom, product, con_num, pricing }) {
      if (!this.form.con_num) { this.form.con_num = con_num }
      this.formGroups[0].formCtrl.map(c => {
        if (c.label == '计价方式' && pricing && pricing.length) {
          this.pricing.push(...pricing)
          c.options = pricing.map(v => {
            return {
              label: v.name,
              value: v.name,
            }
          })

          // console.log('detail', { ...this.detail })
          // console.log('form', { ...this.form })

          if (!this.$route.query.c_id) {
            console.log('合同添加')
            const { pricing_id } = this.detail
            if (!pricing_id) {
              this.$set(this.form, 'pricing_id', pricing[0]['id'])
              this.$set(this.form, 'pricing', pricing[0]['name'])
            } else {
              this.setPricingName()
            }
          }
        } else if (c.keyName == 'shipperid' && custom && custom.length) {
          c.options = custom.map(v => {
            return {
              label: `${v.name}-${v.member}`,
              value: v.id,
            }
          })
        } else if (c.keyName == 'shname' && custom && custom.length) {
          this.custom = [...custom]
          this.setCustom()
          c.options = custom.map(v => {
            return {
              label: v.name + '-' + v.member,
              value: v.name + '-' + v.member,
            }
          })
        } else if (c.keyName == 'nid' && product && product.length) {
          c.options = product.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
        } else if (c.keyName == 'name' && product && product.length) {
          this.product = [...product]
          c.options = product.map(v => {
            return {
              label: v.name,
              value: v.name,
            }
          })
        }
        this.$forceUpdate()
      })
    },

    setPricingName(pricingId) {
      if (!this.detail['pricing_id']) {
        console.log('detail 还未获取到')
      }
      if (!this.pricing) {
        console.log('pricing 还未获取到')
      }
      const pricing_id = pricingId || this.detail['pricing_id']
      if (pricing_id && this.pricing && this.pricing.length) {
        this.pricing.map(v => {
          if (v.id == pricing_id) {
            this.$set(this.form, 'pricing', v['name'])
            if (!this.form['pricing_id']) {
              this.form['pricing_id'] = pricing_id
            }
          }
        })
      }
    },

    onInput({ key, value }) {
      // console.log(key, value, this.form.shipperid)
      const id = this.form.shipperid
      if (id && value) {
        this.inputSearch(id, key, value)
      } else if (!value) {
        if (key === 'drman') {
          this.formGroups[1].formCtrl[1]['options'] = []
          this.$set(this.form, key, value)
        } else if (key === 'coaddress') {
          this.formGroups[1].formCtrl[0]['options'] = []
          this.$set(this.form, key, value)
        } if (key === 'enman') {
          this.formGroups[2].formCtrl[1]['options'] = []
          this.$set(this.form, key, value)
        } if (key === 'enaddress') {
          this.formGroups[2].formCtrl[0]['options'] = []
          this.$set(this.form, key, value)
        }
        this.$forceUpdate()
      }
      // console.log({ ...this.form })
    },
    inputSearch(id, key, value) {
      // console.log(id, key, value)
      let url = `order/shippervague`;
      const params = {
        id,
      }
      if (key === 'drman') {
        params['fhperson'] = value
      } else if (key === 'coaddress') {
        params['fhdizhi'] = value
      } if (key === 'enman') {
        params['shperson'] = value
      } if (key === 'enaddress') {
        params['shdizhi'] = value
      } else if (!['drman', 'coaddress', 'enman', 'enaddress'].includes(key)) {
        return
      }
      // console.log(url, params)
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          if (key === 'drman') {
            this.formGroups[1].formCtrl[1]['options'] = data.map(v => {
              return {
                label: v.member,
                value: v.id,
                data: v,
              }
            })
          } else if (key === 'coaddress') {
            this.formGroups[1].formCtrl[0]['options'] = data.map(v => {
              return {
                label: v.address,
                value: v.id,
                data: v,
              }
            })
          } if (key === 'enman') {
            this.formGroups[2].formCtrl[1]['options'] = data.map(v => {
              return {
                label: v.member,
                value: v.id,
                data: v,
              }
            })
          } if (key === 'enaddress') {
            this.formGroups[2].formCtrl[0]['options'] = data.map(v => {
              return {
                label: v.address,
                value: v.id,
                data: v,
              }
            })
          }
          this.$forceUpdate()
          // console.log([...this.formGroups[1].formCtrl])
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onSelect({ key, value }) {
      // console.log(key, { ...value })
      if (key === 'drman' && value) {
        this.formGroups[1].formCtrl[1]['options'] = []
        this.$set(this.form, key, value['member'])
        this.$set(this.form, 'drtel', value['phone'])
      } else if (key == 'coaddress' && value) {
        this.formGroups[1].formCtrl[0]['options'] = []
        this.$set(this.form, key, value['address'])
      } if (key === 'enman' && value) {
        this.formGroups[2].formCtrl[1]['options'] = []
        this.$set(this.form, key, value['member'])
        this.$set(this.form, 'ertel', value['phone'])
      } if (key === 'enaddress' && value) {
        this.formGroups[2].formCtrl[0]['options'] = []
        this.$set(this.form, key, value['address'])
      }
      this.$forceUpdate()
    },

    getReportOrder() {
      let url = `declaration/item`;
      const params = {
        id: this.r_id,
      }

      this.post(url, params, ({ msg, data }) => {
        // console.log(data)
        if (msg === 'success' && data) {
          const {
            p_id,
            product,
            pricing,
            pricing_id,
            quantity,
            coaddress,
            drman,
            drtel,
            enaddress,
            enman,
            ertel,
          } = data

          this.form = {
            ...this.form,
            d_id: this.r_id,
            shipperid: this.c_id,
            nid: p_id,
            name: product,
            pricing,
            pricing_id,
            ton: quantity,
            coaddress,
            drman,
            drtel,
            enaddress,
            enman,
            ertel,
          }

          this.setCustom()
          this.setPricingName()
          this.$forceUpdate()
          console.log('报单创建合同')

          console.log('form', { ...this.form })
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },

    setCustom() {
      // 再派一单获取detail，取出shipperid
      let { shipperid, shname } = this.detail
      console.log(shipperid, shname)
      // 如果是报单派单，不获取detail，通过c_id获取详情信息
      if (this.c_id) {
        shipperid = this.c_id
      }
      if (this.custom && this.custom.length) {
        this.custom.map(v => {
          // 匹配shipperid，设置合成用户名
          if (v.id == shipperid) {
            this.$set(this.form, 'shname', v.name + '-' + v.member)
            this.$forceUpdate()
            // console.log('form', { ...this.form })
          }
        })
      }
    },
  },
  created() {
    if (this.mode === 'edit') {
      this.formGroups[0].formCtrl[1].disabled = true
    }
    if (this.$route.path.includes('/reportOrder/addContract')) {
      // 客户报单派单
      this.breadcrumb = [
        { name: "报单管理", path: `/reportOrder/list` },
        { name: "报单列表", path: `/reportOrder/list` },
        { name: "创建合同" }
      ]
    }
  },
  mounted() {
    this.getOptions()

    const { c_id, r_id } = this.$route.query
    // console.log(c_id)
    if (c_id) {
      this.c_id = c_id
      this.r_id = r_id
      this.formGroups[0].formCtrl.map(v => {
        if (v.keyName === 'shname') {
          v.disabled = true
        }
      })
      this.getReportOrder()
    }
  },
};
</script>

<style lang="less" scoped>
.info_form {
  /deep/ .el-form {
    .el-form-item {
      .el-input__inner.el-date-editor--daterange {
        width: 300px;
      }
    }
  }
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
